import { FC } from 'react';
import styles from './Tabs.styles.module.css';

export enum TabsVariant {
  SPACED = 'SPACED',
  COMPACT = 'COMPACT',
}
interface TabsProps {
  children: React.ReactNode;
  variant?: TabsVariant;
  customStyle?: string;
  selectionInfo?: React.ReactNode;
}

const variantClassesMap = {
  [TabsVariant.SPACED]: styles.tabs,
  [TabsVariant.COMPACT]: `${styles.tabs} ${styles['tabs--compact']}`,
};

const Tabs: FC<TabsProps> = ({
  children,
  variant = TabsVariant.SPACED,
  customStyle = '',
  selectionInfo,
}) => {
  const variantClass = variantClassesMap[variant];

  return (
    <div className={`${styles.tabsContainer} ${customStyle}`}>
      <div role='tablist' className={variantClass}>
        {children}
      </div>
      {selectionInfo && (
        <div className={styles.selectionInfo}>{selectionInfo}</div>
      )}
    </div>
  );
};

Tabs.displayName = 'Tabs';
export default Tabs;
